import styled from "styled-components";

export const ChatbotGeneralCase = styled.div`
  height: 100%;
  display: flex;
  flex-direction: column;
  .chatbot-container {
    flex: 1;
    padding: 20px 14px 0px 29px;
    display: flex;
    flex-direction: column;
    overflow-y: scroll;
    min-height: 300px;
    &__empty {
      margin: auto;
      display: flex;
      flex-direction: column;
      align-items: center;
    }
    &__empty-container {
      width: 180px;
      position: relative;
      display: flex;
      justify-content: center;
      &__shadow {
        z-index: 1;
        display: flex;
        /* width: 10px; */
        /* height: 10px; */
        position: absolute;
        align-self: center;
        box-shadow: 0px 3.03px 121.47px 60px #3e76fa66;
      }
    }
    &__empty-image {
      width: 180px;
      height: 100%;
      z-index: 2;
    }
    &__empty-msg {
      margin-top: 20px;
      font-size: 17px;
      color: #707582;
    }
  }
  .chatbot-footer {
    padding: 20px;
    box-sizing: border-box;
  }
`;
